export default __webpack_public_path__ + "static/media/mockup-magazine.8650626e.png";